import { useState, useEffect } from 'react';

interface TypewriterTextProps {
  text: string | string[];
  speed?: number;
  delay?: number;
  className?: string;
  showCursor?: boolean;
  onComplete?: () => void;
}

export function TypewriterText({
  text,
  speed = 50,
  delay = 0,
  className = '',
  showCursor = true,
  onComplete
}: TypewriterTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  const lines = Array.isArray(text) ? text : [text];

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (currentLineIndex < lines.length) {
        const currentLine = lines[currentLineIndex];

        if (currentCharIndex < currentLine.length) {
          setDisplayedText(prev => prev + currentLine[currentCharIndex]);
          setCurrentCharIndex(prev => prev + 1);
        } else {
          if (currentLineIndex < lines.length - 1) {
            setDisplayedText(prev => prev + '\n');
            setCurrentLineIndex(prev => prev + 1);
            setCurrentCharIndex(0);
          } else {
            setIsComplete(true);
            onComplete?.();
          }
        }
      }
    }, currentLineIndex === 0 && currentCharIndex === 0 ? delay : speed);

    return () => clearTimeout(timeout);
  }, [currentLineIndex, currentCharIndex, lines, speed, delay, onComplete]);

  return (
    <span className={className}>
      {displayedText.split('\n').map((line, i) => (
        <span key={i}>
          {line}
          {i < displayedText.split('\n').length - 1 && <br />}
        </span>
      ))}
      {showCursor && !isComplete && (
        <span className="animate-blink text-cyber-green">|</span>
      )}
    </span>
  );
}
